import { partial } from '../../../util/translation/translation';
import { isValidKrInput, krInputToOre, MIN_PRICE_ORE } from '../payments';

const p = partial('validateErrors.participantFormErrors');

const validateEmailInvite = (values) => {
  const errors = {};

  if (!values.email) {
    errors.email = p('emailFieldCantBeEmpty');
  }

  if (!values.guestAmount) {
    errors.guestAmount = p('numberOfGuestsFieldCantBeEmpty');
  }

  // Paid events: the invite's price (empty or 0 = free) and booking fee
  const ep = partial('EventPayments');
  if (!isValidKrInput(values.price)) {
    errors.price = ep('errorAmount');
  } else if (
    krInputToOre(values.price) > 0 &&
    krInputToOre(values.price) < MIN_PRICE_ORE
  ) {
    errors.price = ep('errorPriceTooLow', { amount: MIN_PRICE_ORE / 100 });
  }
  if (!isValidKrInput(values.bookingFee)) {
    errors.bookingFee = ep('errorAmount');
  }

  return errors;
};

export default validateEmailInvite;
